import React from 'react';
import styled from 'styled-components';
import Divider from 'antd/lib/divider';
import AntdButton from 'antd/lib/button';
import { Link } from 'react-router-dom';

import { LoadingOutlined } from '@ant-design/icons';

import Admin from 'hive-admin';
import Page from 'hive-admin/src/components/Page';
import { QueryBuilder } from 'hive-admin/src/components/Filters';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  stringify as stringifyQuery,
} from 'querystring';

// import getFilterWithCol from '../../helpers/getFilterWithCol';
// import createActionFilterLink from '../../helpers/createActionFilterLink';

import { Query as OrdersChartQuery } from '../../components/Charts';

import {
  ADMIN as FILTERS_ADMIN,
  ADMIN_APPROVAL as FILTERS_ADMIN_APPROVAL,
  SELLER as FILTERS_SELLER,
  SELLER_APPROVAL as FILTERS_SELLER_APPROVAL,
} from './filters';
import {
  ADMIN as COLUMNS_ADMIN,
  ADMIN_APPROVAL as COLUMNS_ADMIN_APPROVAL,
  SELLER_MERCHANT as COLUMNS_SELLER_MERCHANT,
  SELLER_MERCHANT_APPROVAL as COLUMNS_SELLER_MERCHANT_APPROVAL,
  SELLER_REFERRAL as COLUMNS_SELLER_REFERRAL,
  SELLER_RESELLER as COLUMNS_SELLER_RESELLER,
} from './columns';
import {
  ADMIN_EDIT as FIELDS_ADMIN_EDIT,
  ADMIN_CREATE as FIELDS_ADMIN_CREATE,
  SELLER_MERCHANT_EDIT as FIELDS_SELLER_MERCHANT_EDIT,
  SELLER_MERCHANT_CREATE as FIELDS_SELLER_MERCHANT_CREATE,
  SELLER_REFERRAL_EDIT as FIELDS_SELLER_REFERRAL_EDIT,
  SELLER_REFERRAL_CREATE as FIELDS_SELLER_REFERRAL_CREATE,
  SELLER_RESELLER_EDIT as FIELDS_SELLER_RESELLER_EDIT,
  SELLER_RESELLER_CREATE as FIELDS_SELLER_RESELLER_CREATE,
} from './fields';
import {
  ADMIN as ACTIONS_ADMIN,
  SELLER_MERCHANT as ACTIONS_SELLER_MERCHANT,
  SELLER_REFERRAL as ACTIONS_SELLER_REFERRAL,
  SELLER_RESELLER as ACTIONS_SELLER_RESELLER,
} from './actions';

const Button = styled(AntdButton)`
  margin-left: 10px;
`;

export default [
  ['ADMIN', {
    path: '/orders',
  }],
  ['SELLER_MERCHANT', {
    path: '/store/orders',
    archiveLoadUrl: '/orders',
  }],
  ['SELLER_REFERRAL', {
    path: '/store/partners/orders',
    archiveLoadUrl: '/orders',
  }],
  ['SELLER_RESELLER', {
    path: '/store/reseller/orders',
    archiveLoadUrl: '/orders',
  }],
].reduce(
  (pages, [specificRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS_EDIT,
      FIELDS_CREATE,
      ACTIONS,
    ] = (
        specificRole === 'ADMIN'
      ? [
          COLUMNS_ADMIN,
          FILTERS_ADMIN,
          FIELDS_ADMIN_EDIT,
          FIELDS_ADMIN_CREATE,
          ACTIONS_ADMIN,
        ]
      : specificRole === 'SELLER_MERCHANT'
      ? [
          COLUMNS_SELLER_MERCHANT,
          FILTERS_SELLER,
          FIELDS_SELLER_MERCHANT_EDIT,
          FIELDS_SELLER_MERCHANT_CREATE,
          ACTIONS_SELLER_MERCHANT,
        ]
      : specificRole === 'SELLER_REFERRAL'
      ? [
          COLUMNS_SELLER_REFERRAL,
          FILTERS_SELLER,
          FIELDS_SELLER_REFERRAL_EDIT,
          FIELDS_SELLER_REFERRAL_CREATE,
          ACTIONS_SELLER_REFERRAL,
        ]
      : specificRole === 'SELLER_RESELLER'
      ? [
          COLUMNS_SELLER_RESELLER,
          FILTERS_SELLER,
          FIELDS_SELLER_RESELLER_EDIT,
          FIELDS_SELLER_RESELLER_CREATE,
          ACTIONS_SELLER_RESELLER,
        ]
      : []
    );
    const redirect = [
      ['redirect.unauthorized'],
      [
        'redirect.viewerSpecificRoleIsNot',
        specificRole,
        currentSpecificRole => (
            currentSpecificRole === 'ADMIN'
          ? '/orders'
          : currentSpecificRole === 'SELLER_MERCHANT'
          ? '/store/orders'
          : currentSpecificRole === 'SELLER_REFERRAL'
          ? '/store/partners/orders'
          : currentSpecificRole === 'SELLER_RESELLER'
          ? '/store/reseller/orders'
          : null
        ),
      ],
    ];
    const hidden = [
      ['condition.viewerSpecificRoleIsNot', specificRole],
    ];
    if (specificRole !== 'ADMIN') {
      pages.push(['PagePOSOutlet', {
        title: 'POS Outlet',
        hidden: true,
        path: `${config.path}/outlet`,
        hideHeader: true,
        hideSidebar: true,
        redirect,
      }]);
    }
    switch (specificRole) {
      case 'ADMIN':
      case 'SELLER_MERCHANT': {
        const pendingApprovalPath = (
            specificRole === 'ADMIN'
          ? '/orders/pending'
          : specificRole === 'SELLER_MERCHANT'
          ? '/store/orders/pending'
          : null
        );
        const [
          COLUMNS_APPROVAL,
          FILTERS_APPROVAL,
        ] = (
            specificRole === 'ADMIN'
          ? [COLUMNS_ADMIN_APPROVAL, FILTERS_ADMIN_APPROVAL]
          : specificRole === 'SELLER_MERCHANT'
          ? [COLUMNS_SELLER_MERCHANT_APPROVAL, FILTERS_SELLER_APPROVAL]
          : []
        );
        pages.push(...Admin.compileFromLibrary(['GroupResource', {
          title: 'Orders',
          // icon: 'shopping',
          redirect,
          columns: COLUMNS,
          filters: [
            // getFilterWithCol(
            //   createActionFilterLink(
            //     pendingApprovalPath,
            //     'Show Orders Pending Approval',
            //     { id: 'show-orders-pending-approval' },
            //   ),
            //   24,
            // ),
            ...FILTERS,
          ],
          archiveConfig: {
            title: 'All Orders',
            label: 'All Orders',
            // icon: 'shopping',
            titleColumnPath: '_id',
            createButtonLabel: 'Create Order',
            createButtonPath: `${config.path}/create`,
            queryBuilder: new QueryBuilder(),
            hidden,
            getUseFiltersExtra: () => true,
            renderHeaderRight: () => (
              <Link to={pendingApprovalPath}>
                <Button>
                  Show Pending
                </Button>
              </Link>
            ),
            renderBelowTopFilters: props => (
              <>
                <Divider
                  key="chart-divider"
                  style={{ marginTop: '10px' }}
                />
                <OrdersChartQuery
                  client={props.client}
                  url={`/orders/aggregate/status?${stringifyQuery({
                    query: JSON.stringify({
                      where: {
                        AND: props.queryBuilder.where,
                      },
                    }),
                  })}`}
                  viewer={props.viewer}
                />
              </>
            ),
          },
          afterArchivePages: [
            ['PageArchiveTableAutoRefresh', {
              label: 'Pending',
              title: 'Pending',
              // icon: 'exclamation-circle',
              renderHeaderTitle: () => (
                <span>
                  Pending
                  &nbsp;
                  <LoadingOutlined />
                </span>
              ),
              titleColumnPath: '_id',
              createButtonLabel: 'Create Order',
              // getCreateButtonPath: () => `${config.path}/create`,
              getCreateButtonPath: () => undefined,
              renderHeaderRight: () => (
                <Link to={`${config.path}`}>
                  <Button>
                    Show All
                  </Button>
                </Link>
              ),
              path: pendingApprovalPath,
              hidden,
              // alias: config.path,
              exact: true,
              loadUrl: '/orders',
              filters: [
                // getFilterWithCol(
                //   createActionFilterLink(
                //     config.path,
                //     'Show All Orders',
                //     { id: 'show-all-orders' },
                //   ),
                //   24,
                // ),
                ...FILTERS_APPROVAL,
              ],
              columns: COLUMNS_APPROVAL,
              loadExtractData: response => (
                response
                ? { count: response.data.count, data: response.data.data }
                : { count: 0, data: [] }
              ),
            }],
          ],
          singleConfig: {
            hidden: true,
            alias: config.path,
            backButtonPaths: [config.path],
          },
          singleCreateUrl: '/orders/draft',
          singleCreateConfig: {
            title: 'Create Order',
            headerTitle: 'Create Order',
            label: 'Create Order',
            fields: FIELDS_CREATE,
            hidden: [
              () => specificRole === 'ADMIN',
              ...hidden,
            ],
            // icon: 'plus',
            ...(
              specificRole === 'ADMIN'
              ? {}
              : { alias: null, backButtonPaths: false }
            ),
          },
          singleEditConfig: {
            headerTitleKey: '_id',
            title: 'Order',
            renderHeaderTitle: props => (
              <>
                {
                  `Order: ${
                    Page.config.renderHeaderTitle(props)
                  }`
                }
                {
                  props.data?.restored || props.data?.statusAdjusted
                  ? (
                      <>
                        <br />
                        <div
                          style={{
                            fontSize: '40%',
                            opacity: '0.4',
                            textTransform: 'uppercase',
                            lineHeight: '110%',
                          }}
                        >
                          {
                            props.data?.restored
                            ? 'restored'
                            : 'status adjusted'
                          }
                        </div>
                      </>
                    )
                  : null
                }
              </>
            ),
            // eslint-disable-next-line max-len
            loadUrl: 'orders/:id/?store=true&actions=true&discountCode=true&shippingCompany=true&requestSubjects=true&customerStore=true&warehouse=true',
            actions: ACTIONS,
            fields: FIELDS_EDIT,
          },
          ...config,
        }]).pages);
      }
      break;
      case 'SELLER_RESELLER':
        pages.push(...Admin.compileFromLibrary(['GroupResource', {
          title: 'Orders',
          // icon: 'shopping',
          redirect,
          columns: COLUMNS,
          filters: FILTERS,
          archiveConfig: {
            title: 'Orders',
            label: 'Orders',
            // icon: 'shopping',
            titleColumnPath: '_id',
            createButtonLabel: 'Create Order',
            createButtonPath: `${config.path}/create`,
            queryBuilder: new QueryBuilder(),
            hidden,
            renderBelowTopFilters: props => (
              <>
                <Divider
                  key="chart-divider"
                  style={{ marginTop: '10px' }}
                />
                <OrdersChartQuery
                  client={props.client}
                  url={`/orders/aggregate/status?${stringifyQuery({
                    query: JSON.stringify({
                      where: {
                        AND: props.queryBuilder.where,
                      },
                    }),
                  })}`}
                  viewer={props.viewer}
                />
              </>
            ),
          },
          singleConfig: {
            hidden: true,
            alias: config.path,
            backButtonPaths: [config.path],
          },
          singleCreateUrl: '/orders/draft',
          singleCreateConfig: {
            title: 'Create Order',
            headerTitle: 'Create Order',
            label: 'Create Order',
            fields: FIELDS_CREATE,
            hidden: [
              () => specificRole === 'ADMIN',
              ...hidden,
            ],
            // icon: 'plus',
            ...(
              specificRole === 'ADMIN'
              ? {}
              : { alias: null, backButtonPaths: false }
            ),
          },
          singleEditConfig: {
            headerTitleKey: '_id',
            title: 'Order',
            renderHeaderTitle: props => `ID: ${
              Page.config.renderHeaderTitle(props)
            }`,
            // eslint-disable-next-line max-len
            loadUrl: 'orders/:id/?store=true&actions=true&discountCode=true&shippingCompany=true&requestSubjects=true',
            actions: ACTIONS,
            fields: FIELDS_EDIT,
          },
          ...config,
        }]).pages);
      break;
      case 'SELLER_REFERRAL':
        pages.push(['PageArchiveTable', {
          title: 'Orders',
          // icon: 'shopping',
          path: config.path,
          exact: true,
          loadUrl: '/orders',
          createButtonSupported: false,
          columns: COLUMNS,
          filters: FILTERS,
          redirect,
          hidden,
          titleColumnPath: '_id',
          loadExtractData: response => (
            response
            ? { count: response.data.count, data: response.data.data }
            : { count: 0, data: [] }
          ),
        }]);
        pages.push(['PageSingle', {
          title: 'Order',
          activity: 'edit',
          path: `${config.path}/:id`,
          alias: config.path,
          loadUrl: '/orders/:id',
          backButtonPaths: [config.path],
          actions: [],
          fields: FIELDS_EDIT,
          redirect,
          hidden: true,
        }]);
      break;
      default:
    }
    return pages;
  },
  [],
);
